import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import config from '../functions/config';


function PaymentPage() {
  const navigate = useNavigate();
  const { rentalId } = useParams(); // Extract rentalId from the URL parameter

  // Handle Payment Function
  const handlePayment = async () => {
    try {
      const response = await fetch(`${config.BASE_URL}/api/manage-payments/${rentalId}/`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          status: "paid",
        }),
      });

      if (response.ok) {
        alert("Payment processed successfully!");
        navigate("/rentalhistory"); // Navigate to the rental history page after payment
      } else {
        alert("Failed to process payment. Please try again.");
      }
    } catch (error) {
      console.error("Error processing payment:", error);
      alert("An error occurred. Please try again.");
    }
  };

  return (
    <div>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            Library Management
          </a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
            <li className="nav-item">
                <a className="nav-link" href="/success">
                   Books
                </a>
              </li>
              <li className="nav-item">

                <a className="nav-link" href="/userhome">
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/profile">
                  Profile
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/rentalhistory">
                  Rented Books
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/purchasehistory">
                  Purchase History
                </a>
              </li>
              <li className="nav-item">
                <a href="/login" className="btn btn-danger">
                  Logout
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Payment Options */}
      <div className="container mt-5 pt-5">
        <h2 className="text-center my-4">Choose Your Payment Method</h2>
        <div className="row justify-content-center">
          <div className="col-md-4">
            <div className="card text-center shadow">
              <div className="card-body">
                <h5 className="card-title">GPay</h5>
                <p className="card-text">Pay quickly and securely using Google Pay.</p>
                <button className="btn btn-primary" onClick={handlePayment}>
                  Pay with GPay
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card text-center shadow">
              <div className="card-body">
                <h5 className="card-title">Card Payment</h5>
                <p className="card-text">Use your credit or debit card for payment.</p>
                <button className="btn btn-success" onClick={handlePayment}>
                  Pay with Card
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card text-center shadow">
              <div className="card-body">
                <h5 className="card-title">Net Banking</h5>
                <p className="card-text">Pay directly from your bank account.</p>
                <button className="btn btn-warning" onClick={handlePayment}>
                  Pay with Banking
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentPage;
